import { Body } from "components/src/components/Typography/Typography";
import cx from "components/src/utils/cx";
import { useSync } from "shared/src/hooks/useSync";

export const CompetitorDescription = (props) => {
  const propsWithSync = useSync(props);
  const { description, inverse, variant, forcedReadableToken } = propsWithSync;
  if (!description) return null;
  const isHorizontalVariant = variant === "horizontal";
  return (
    <Body
      size="xs"
      className={cx(
        {
          "cui-text-right": inverse && isHorizontalVariant,
          "cui-text-center": !isHorizontalVariant,
          "cui-mt-2px": !isHorizontalVariant,
          // "-cui-mt-2px": isHorizontalVariant,
        },
        "cui-m-0 cui-line-clamp-1"
      )}
      color={forcedReadableToken ? forcedReadableToken : null}
    >
      {description}
    </Body>
  );
};
